import "./AboutUs.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import OurTeam from "./sections/OurTeam";
import OurValues from "./sections/OurValues";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <MainNavigation />
      <OurStory />
      <OurTeam />
      <OurValues />
      <Footer />
    </div>;
}